module.exports = __webpack_public_path__ + "static/ArtjokerVCRU-4ae231f7770b0d92d2a124bf6c130061.png";